import { sanitize } from '../util';

const normalize = stringValue => !stringValue ? '' : sanitize( stringValue );

export const getRouteToName = ( category, fromDisclaimerPopUp = false, fromBreadCrumb = false ) => {
  // change as requested by Emmy, use nodeId over uuid
  // this requires that nodeIds are unique (which used to be handled by uuid to make sure the links were unique)
  // in HomeApp, the check to see if the path matches the uuid or the nodeid is being done so old links should remain valid
  // the new links will now have the nodeId only
  
  if ( !category.customProperties.nodeMessage || fromDisclaimerPopUp || fromBreadCrumb ) {
    const normalizedUuid = normalize( category.nodeId );
    if ( category.isConfiguratorSelector ) {
      return `/configuratorSelector/${ normalizedUuid }`;
    }
    if ( category.isConfigurator ) {
      return `/configurator/${ normalizedUuid }`;
    }
    if ( category.isSelector ) {
      return `/selector/${ normalizedUuid }`;
    }
    return `/categories/${ normalizedUuid }`;
  }
};